"use strict";
/*
 * indicative-parser
 *
 * (c) Harminder Virk <virk@adonisjs.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
*/
Object.defineProperty(exports, "__esModule", { value: true });
const getBaseRules_1 = require("./getBaseRules");
/**
 * Returns runtime node for an object type.
 */
function getObjectType(schema, isOptional) {
    return {
        getTree() {
            return {
                type: 'object',
                rules: getBaseRules_1.getBaseRules('object', isOptional),
                children: Object.keys(schema).reduce((result, key) => {
                    result[key] = schema[key].getTree();
                    return result;
                }, {}),
            };
        },
    };
}
exports.getObjectType = getObjectType;
